// System and utility routes module
import ActivityLog from '@/router/ActivityLog.js';
import BellCurve from '@/router/BellCurve.js';
import CourseCodes from '@/router/CourseCodes.js';
import EditPages from '@/router/EditPages.js';
import EdverumInsights from '@/router/EdverumInsights.js';
import IdentityVerification from '@/router/IdentityVerification.js';
import ImpersonationLog from '@/router/ImpersonationLog.js';
import Inbox from '@/router/Inbox.js';
import Interventions from '@/router/Interventions.js';
import ProctorDashboard from '@/router/ProctorDashboard.js';
import QuizDashboard from '@/router/QuizDashboard.js';
import Remediations from '@/router/Remediations.js';
import Schedule from '@/router/Schedule.js';
import Search from '@/router/Search.js';
import StudentSupport from '@/router/StudentSupport.js';

export default [
    ...ActivityLog,
    ...ImpersonationLog,
    ...BellCurve,
    ...CourseCodes,
    ...EditPages,
    ...EdverumInsights,
    ...StudentSupport,
    ...IdentityVerification,
    ...Inbox,
    ...Interventions,
    ...ProctorDashboard,
    ...QuizDashboard,
    ...Remediations,
    ...Schedule,
    ...Search,
];
